import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const FadeIn = styled('div', { label: 'FadeIn' })`
    animation: ${fadeIn} 200ms ease-out;
`;
